import React from "react";
import { Box, Button, List, useMediaQuery, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import NavItem from "./SidebarNavItem";
import { Home as HomeIcon } from "@mui/icons-material";
import { ROUTES } from "@/shared/constants";
import { guestAuthButtonSx, sidebarTheme, SidebarShell } from "./sidebarDesign";

const guestNavItems = [{ text: "Lobby", icon: <HomeIcon />, path: ROUTES.LOBBY }];

type GuestSidebarProps = {
  open: boolean;
  handleClose: () => void;
  toggleDrawer?: () => void;
};

const GuestSidebar = ({ open, handleClose, toggleDrawer }: GuestSidebarProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();
  const showRailTooltip = !isMobile && !open;

  const handleNavigation = (path: string) => {
    navigate(path);
    if (isMobile) {
      handleClose();
    }
  };

  return (
    <SidebarShell
      open={open}
      isMobile={isMobile}
      onClose={handleClose}
      onToggle={toggleDrawer}
      body={
        <Box sx={{ display: "flex", flexDirection: "column", pt: 4 }}>
          <List disablePadding sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {guestNavItems.map((item) => (
              <NavItem
                key={item.text}
                variant="landing"
                item={item}
                open={!showRailTooltip}
                selected={location.pathname === item.path}
                onClick={isMobile ? handleClose : undefined}
              />
            ))}
          </List>
        </Box>
      }
      footer={
        isMobile ? (
          <Box sx={{ p: 2, borderTop: `1px solid ${sidebarTheme.borderSubtle}`, mb: 1 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Button
                fullWidth
                onClick={() => handleNavigation("/sign-in")}
                sx={guestAuthButtonSx.outline}
              >
                Login
              </Button>
              <Button
                fullWidth
                variant="contained"
                disableElevation
                onClick={() => handleNavigation("/register")}
                sx={guestAuthButtonSx.primary}
              >
                Sign Up
              </Button>
            </Box>
          </Box>
        ) : undefined
      }
    />
  );
};

export default GuestSidebar;
